/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { Marker } from "react-map-gl";
import { moneyWithoutDecimals } from "helpers/formatting";
import styles from "components/shared/stays/MapMarkerStatic.module.scss";

export default function MapMarkerStatic({ latitude, longitude, lowestPrice }) {
  const pointRef = useRef(null);

  const [offsets, setOffsets] = useState({
    top: 0,
    left: 0,
  });

  const formattedPrice = moneyWithoutDecimals(lowestPrice);

  useEffect(() => {
    setOffsets({
      top: -(pointRef.current?.offsetHeight || 0 / 2),
      left: -(pointRef.current?.offsetWidth || 0 / 2),
    });
  }, []);

  return (
    <Marker
      latitude={latitude}
      longitude={longitude}
      offsetLeft={offsets.left}
      offsetTop={offsets.top}
      className={styles.component}
    >
      <div className={styles.point} ref={pointRef}>
        {formattedPrice}
      </div>
    </Marker>
  );
}

MapMarkerStatic.propTypes = {
  latitude: PropTypes.number.isRequired,
  longitude: PropTypes.number.isRequired,
  lowestPrice: PropTypes.node.isRequired,
};
